export enum PageRoute {
    MONITOR_ROUTE = '/',
    CONFIGURE_ROUTE = '/configure',
    LICENSE_ROUTE = '/license',
    ABOUT_ROUTE = '/about',
}
